export default __webpack_public_path__ + "c24de6963d7d00c269db34091059e06d.js";